import { Component, OnInit, EventEmitter, Output, ViewChild, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { each, groupBy } from 'lodash';
import { NotificationService } from 'src/app/Service/notification.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowActionCartOutputModel } from 'src/app/ViewModel/WorkflowActionModel';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';
import { WFTCartDialogOutputModel, WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { WftActionKendoDialogComponent } from '../wft-action-kendo-dialog/wft-action-kendo-dialog.component';
import { WftCartDialogComponent } from '../wft-cart-dialog/wft-cart-dialog.component';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';

@Component({
	selector: 'app-wftd-body-input',
	templateUrl: './wftd-body-input.component.html',
	styleUrls: ['./wftd-body-input.component.css']
})
export class WftdBodyInputComponent implements OnInit {
	@ViewChild(WftActionKendoDialogComponent) actionComponent!: WftActionKendoDialogComponent;
	@Input() TemplateDetails: any;
	@Output() getInputValues = new EventEmitter();
	formGroup: FormGroup = new FormGroup({});
	isTransmittalSelectionRequired = false;
	isDisabled_dueDays = false;
	workFlowTaskList: RoleFeatureModel[] = [];
	workFlowTaskListCopy: RoleFeatureModel[] = [];
	statusList: RoleFeatureModel[] = [];
	integrateToList: RoleFeatureModel[] = [];
	transmittalCollection: any = [];
	selectedWorkflowTaskClear = 'N';
	selectedStatusClear = 'N';
	selectedIntegrateToClear = 'N';
	selectedWorkFlowTaskDescription = '';

	/** To: cart output data */
	toCartOutputData!: WFTCartDialogOutputModel | null;
	/** Cc: cart output data */
	ccCartOutputData!: WFTCartDialogOutputModel | null;
	/** Workflow action cart output data */
	actionCartOutputData: WorkflowActionCartOutputModel[] | null = [];

	parentWorkflowId: number | null = null;
	parentTaskId: number | null = null;

	/** Bottom kendo list */
	bottomKendoList: any = [];

	constructor(private _transmittalService: TransmittalService,
		public commonService: CommonService,
		private dialog: MatDialog,
		public notificationService: NotificationService,
		public workflowTemplateService: WorkflowTemplateService,
	) {
		if (this.workflowTemplateService.isViewMode)
			this.isDisabled_dueDays = true;
		else
			this.isDisabled_dueDays = false;

		this.setFormDefaultValues();
	}

	ngOnInit() {
		this.getWorkFlowTaskList();
		this.getStatusList();
		this.getIntegrateToList();
		this.getTransmittalDetails();

		this.workflowTemplateService.supportForClearInputData.subscribe(data => {
			if (data) {
				this.clearInputValues();
			}
		});

		this.workflowTemplateService.supportForBottomKendo.subscribe(data => {
			if (data && data.length) {
				this.bottomKendoList = data;
				//this.parentTaskId = this.bottomKendoList.length + 1;
				this.workflowTemplateService.customTaskId = this.bottomKendoList.length + 1;
			} else {
				//this.parentTaskId = 1;
				this.workflowTemplateService.customTaskId = 1;
				this.bottomKendoList = [];
			}
			this.syncBottomKendoListWithWfTaskList();
		});
	}

	/**
	 * Set form new values
	 */
	setFormDefaultValues() {
		this.formGroup = new FormGroup({
			"workflow_Id": new FormControl(null),
			"task_Id": new FormControl(null), // data maintain. I ve to create, no data ==1, kendo data length +1
			"task_Order": new FormControl(1), // data maintain, hide in ui
			"step_Id": new FormControl(null), // == task id, both same value
			"workflow_Status": new FormControl(null), // set - workflow eip dd id
			"workflow_Status_Description": new FormControl(''), // set - workflow eip dd desc
			"due_Days": new FormControl({
				value: 1,
				disabled: this.isDisabled_dueDays
			}), //set
			"task_Group": new FormControl(0), // 0, by default, ui hide
			"status_Id": new FormControl(null), // set - status eip dd id
			"workflow_Status_Id_Description": new FormControl(''), // set - status eip dd desc
			"sub_Workflow": new FormControl(null), // null, by default, ui hide
			"transmittal_Page": new FormControl(null), // hide in ui, default value null
			"integration_Type": new FormControl(null), // set, eip dd
			"is_Comment_Sheet": new FormControl(false), // false by default,set
			"is_Completed_On_Manual": new FormControl(false), // set 
			"is_Approval_Status": new FormControl(false), // set 
			"complete_All_Task": new FormControl(false), // set
			"is_Delegate": new FormControl(false), // set
			"is_Action_Required": new FormControl(false), // set
			"is_Communication_Required": new FormControl(false), // set
			"is_Report_Required": new FormControl(false), // set
			"is_Show_Attachment_In_DTN": new FormControl(false), // set
			"Is_SignedCopy_Required": new FormControl(false), // set
			"is_Active": new FormControl(true), // set 
			"is_Due_On": new FormControl(false), // set
			"toSelectedNames": new FormControl({
				value: '',
				disabled: true
			}),
			"ccSelectedNames": new FormControl({
				value: '',
				disabled: true
			}),
			"is_CCN_Required": new FormControl(false), // set
			"is_No_Of_Sheets_Required": new FormControl(false), // set
			"can_Update_DCI_Progress_Level": new FormControl(false), // set
			"is_Step_For_Reassignment": new FormControl(true),
		});

	}

	public getTransmittalDetails() {
		this._transmittalService.GetTransmittalDetails({
			project_Id: this.commonService.getProjectId(),
			group_Id: this.commonService.getLoggedInUserGroupId()
		})
			.subscribe(res => {
				this.transmittalCollection = res;
			});
	}

	public onChange_Transmittal(event: any) {
		if (event.value != -2) {
			this.formGroup.get('transmittal_Page')?.setValue(null)
		} else {
			this.formGroup.get('transmittal_Page')?.setValue(null);
		}
	}

	/**
	 * Remove workflow task name, if exist in bottom kendo data
	 */
	syncBottomKendoListWithWfTaskList() {
		return;
		if (this.bottomKendoList.length) {
			let grpdBottomKendoDataById = groupBy(this.bottomKendoList, 'workflow_Status');
			let temp = [];
			if (this.bottomKendoList.length) {
				temp = [];
				this.workFlowTaskListCopy.forEach(each => {
					if (!(grpdBottomKendoDataById[each.dedId] && grpdBottomKendoDataById[each.dedId].length)) {
						temp.push(each);
					}
				});
				this.workFlowTaskList = temp;
			} else {
				this.workFlowTaskList = this.workFlowTaskListCopy;
			}
		} else {
			this.workFlowTaskList = this.workFlowTaskListCopy;
		}
	}

	/**
	 * Clear input values
	 * @param input 
	 */
	clearInputValues(input?: string) {
		this.parentTaskId = this.bottomKendoList.length ? this.bottomKendoList.length + 1 : null;
		this.selectedWorkflowTaskClear = 'Y';
		this.selectedStatusClear = 'Y';
		this.selectedIntegrateToClear = 'Y';

		this.setFormDefaultValues();
		this.toCartOutputData = null;
		this.ccCartOutputData = null
		this.actionCartOutputData = null;
		this.workflowTemplateService.supportForClearSelectedWfStatus.next(true);

		if (input && input == 'Reset') {
			this.workflowTemplateService.supportForClearMainData.next(true);
		}
	}




	/**
	 * Set exisiting form values
	 */
	setFormValues(parentData: {
		inputData: WorkflowTemplateStatusInputModel,
		toCartValues: WFTCartDialogOutputModel,
		ccCartValues: WFTCartDialogOutputModel,
		actionKendoArr: any[],
		isFromWfTemplateList: boolean | undefined,
		WorkflowActionCategory: any
	}) {
		// this.parentWorkflowId = 0;
		this.setFormDefaultValues();
		if (!parentData.isFromWfTemplateList) {
			this.setFullWorkflowTaskList();
			this.formGroup.get('workflow_Id')?.setValue(parentData.inputData.workflow_Id);
			this.formGroup.get('task_Id')?.setValue(parentData.inputData.task_Id);
			this.formGroup.get('task_Order')?.setValue(parentData.inputData.task_Order);
			this.formGroup.get('step_Id')?.setValue(parentData.inputData.step_Id);
			this.formGroup.get('workflow_Status')?.setValue(parentData.inputData.workflow_Status);
			this.formGroup.get('workflow_Status_Description')?.setValue(parentData.inputData.workflow_Status_Description);
			this.formGroup.get('due_Days')?.setValue(parentData.inputData.due_Days);
			this.formGroup.get('status_Id')?.setValue(parentData.inputData.status_Id);
			this.formGroup.get('workflow_Status_Id_Description')?.setValue(parentData.inputData.workflow_Status_Id_Description);
			this.formGroup.get('sub_Workflow')?.setValue(parentData.inputData.sub_Workflow);
			this.formGroup.get('transmittal_Page')?.setValue(parentData.inputData.transmittal_Page);
			this.formGroup.get('integration_Type')?.setValue(parentData.inputData.integration_Type);
			this.formGroup.get('is_Comment_Sheet')?.setValue(parentData.inputData.is_Comment_Sheet);
			this.formGroup.get('is_Completed_On_Manual')?.setValue(parentData.inputData.is_Completed_On_Manual);
			this.formGroup.get('is_Approval_Status')?.setValue(parentData.inputData.is_Approval_Status);
			this.formGroup.get('complete_All_Task')?.setValue(parentData.inputData.complete_All_Task);
			this.formGroup.get('is_Delegate')?.setValue(parentData.inputData.is_Delegate);
			this.formGroup.get('is_Action_Required')?.setValue(parentData.inputData.is_Action_Required);
			this.formGroup.get('is_Communication_Required')?.setValue(parentData.inputData.is_Communication_Required);
			this.formGroup.get('Is_SignedCopy_Required')?.setValue(parentData.inputData.is_SignedCopy_Required);
			this.formGroup.get('is_Report_Required')?.setValue(parentData.inputData.is_Report_Required);
			this.formGroup.get('is_Show_Attachment_In_DTN')?.setValue(parentData.inputData.is_Show_Attachment_In_DTN);
			this.formGroup.get('can_Update_DCI_Progress_Level').setValue(parentData.inputData.can_Update_DCI_Progress_Level);
			this.formGroup.get('is_Active')?.setValue(parentData.inputData.is_Active);
			this.formGroup.get('is_Due_On')?.setValue(parentData.inputData.is_Due_On);
			this.formGroup.get('is_CCN_Required')?.setValue(parentData.inputData.is_CCN_Required);
			this.formGroup.get('is_No_Of_Sheets_Required')?.setValue(parentData.inputData.is_No_Of_Sheets_Required);
			this.formGroup.get('toSelectedNames')?.setValue(parentData.toCartValues.totalSelectedNames.toString());
			this.formGroup.get('ccSelectedNames')?.setValue(parentData.ccCartValues.totalSelectedNames.toString());
			this.formGroup.get('is_Step_For_Reassignment')?.setValue(parentData.inputData.is_Step_For_Reassignment);
			this.selectedWorkFlowTaskDescription = this.formGroup.get('workflow_Status_Description')?.value;
			this.toCartOutputData = parentData.toCartValues;
			this.ccCartOutputData = parentData.ccCartValues;
			this.actionComponent.setKendoDataFromParent(parentData.actionKendoArr, parentData.inputData.is_Approval_Status, parentData.WorkflowActionCategory);

			let isintegrationTypeTransmittal = false;
			let data = this.integrateToList.filter(x => x.dedId == parentData.inputData.integration_Type);
			if (data.length > 0) {
				if (data[0].dedDescription.toUpperCase() == 'TRANSMITTAL') {
					isintegrationTypeTransmittal = true;
				}
			}

			if (isintegrationTypeTransmittal == true && parentData.inputData.integration_Type && parentData.inputData.transmittal_Page) {
				this.isTransmittalSelectionRequired = true;
			} else {
				this.isTransmittalSelectionRequired = false;
			}
		} else {
			this.setFormDefaultValues();
			this.toCartOutputData = null;
			this.ccCartOutputData = null;
			this.actionComponent.setKendoDataFromParent([]);
			this.syncBottomKendoListWithWfTaskList();
		}
	}

	setFullWorkflowTaskList() {
		this.workFlowTaskList = this.workFlowTaskListCopy;
	}

	getWorkFlowTaskList() {
		this.workflowTemplateService.getWorkflowTaskList(this.TemplateDetails['SrcBG'], Module.Workflow, "Workflow", null, "Workflow Task", null, null, this.TemplateDetails['SrcProject']).subscribe(data => {
			this.workFlowTaskList = data;
			data.forEach(each => {
				this.workFlowTaskListCopy.push(each);
			})
		});
	}
	getStatusList() {
		this.workflowTemplateService.getWorkflowTaskList(this.TemplateDetails['SrcBG'], Module.Workflow, "Workflow", null, "Workflow Status", null, null, this.TemplateDetails['SrcProject']).subscribe(data => {
			this.statusList = data;
		});
	}

	getIntegrateToList() {
		this.workflowTemplateService.getWorkflowTaskList(this.TemplateDetails['SrcBG'], Module.Workflow, "Workflow", null, "Workflow IntegrateTo", null, null, this.TemplateDetails['SrcProject']).subscribe(data => {
			this.integrateToList = data;
		});
	}

	changeWorkflowTask(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		this.selectedWorkflowTaskClear = 'N';
		if (event.value != '-2') {
			this.selectedWorkFlowTaskDescription = event.text;
			this.formGroup.get('workflow_Status')?.setValue(event.value);
			this.formGroup.get('workflow_Status_Description')?.setValue(event.text);
		} else {
			this.selectedWorkFlowTaskDescription = '';
			this.formGroup.get('workflow_Status')?.setValue(null);
			this.formGroup.get('workflow_Status_Description')?.setValue('');
		}
	}

	changeIntegrateTo(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		this.selectedIntegrateToClear = 'N';
		if (event.value != '-2') {
			this.formGroup.get('integration_Type')?.setValue(event.value);
		} else {
			this.formGroup.get('integration_Type')?.setValue(null);
		}

		if (event.text.toUpperCase() == 'TRANSMITTAL') {
			this.isTransmittalSelectionRequired = true;
		} else {
			this.isTransmittalSelectionRequired = false;
		}
	}

	// set type
	changeStatus(event: any) {
		this.selectedStatusClear = 'N';
		if (event.value != '-2') {
			this.formGroup.get('sub_Workflow')?.setValue(event.value);
			this.formGroup.get('workflow_Status_Id_Description')?.setValue(event.text);
		} else {
			this.formGroup.get('sub_Workflow')?.setValue(null);
			this.formGroup.get('workflow_Status_Id_Description')?.setValue('');
		}
	}

	toggle_IsDueOn(event: any) {
		this.formGroup.get('is_Due_On')?.setValue(event.checked);
	}

	/**
	 * Get Form group value by key
	 * @param keyName
	 */
	getFormGroupValue = (keyName: string): any => this.formGroup.get(keyName)?.value;

	openCartDialog(input: string) {
		if (input == 'TO') {
			let dialogRef = this.dialog.open(WftCartDialogComponent, {
				disableClose: true,
				panelClass: 'mat-dialog-secondary',
				data: {
					'previousBusinessGroupId': (this.toCartOutputData && this.toCartOutputData.previousBusinessGroupId && this.toCartOutputData.previousBusinessGroupId > 0) ? this.toCartOutputData.previousBusinessGroupId : null,
					'roleEventsList': (this.toCartOutputData && this.toCartOutputData.roleEventsList && this.toCartOutputData.roleEventsList.length) ? this.toCartOutputData.roleEventsList : [],
					'memberEventList': (this.toCartOutputData && this.toCartOutputData.memberEventList && this.toCartOutputData.memberEventList.length) ? this.toCartOutputData.memberEventList : [],
					'roleTextWithValue': (this.toCartOutputData && this.toCartOutputData.roleTextWithValue && this.toCartOutputData.roleTextWithValue.length) ? this.toCartOutputData.roleTextWithValue : [],
					'memberTextWithValue': (this.toCartOutputData && this.toCartOutputData.memberTextWithValue && this.toCartOutputData.memberTextWithValue.length) ? this.toCartOutputData.memberTextWithValue : [],
					'isCc': false,
					'TemplateDetails': this.TemplateDetails
				}
			});

			dialogRef.afterClosed().subscribe((output: WFTCartDialogOutputModel) => {
				if (output) {
					this.toCartOutputData = output;
					let tooltipData = (this.toCartOutputData && this.toCartOutputData.totalSelectedNames) ? this.toCartOutputData.totalSelectedNames : '';
					this.formGroup.get('toSelectedNames')?.setValue(tooltipData);
				}
			});
		} else {
			let dialogRef = this.dialog.open(WftCartDialogComponent, {
				disableClose: true,
				panelClass: 'mat-dialog-secondary',
				data: {
					'previousBusinessGroupId': (this.ccCartOutputData && this.ccCartOutputData.previousBusinessGroupId && this.ccCartOutputData.previousBusinessGroupId > 0) ? this.ccCartOutputData.previousBusinessGroupId : null,
					'roleEventsList': (this.ccCartOutputData && this.ccCartOutputData.roleEventsList && this.ccCartOutputData.roleEventsList.length) ? this.ccCartOutputData.roleEventsList : [],
					'memberEventList': (this.ccCartOutputData && this.ccCartOutputData.memberEventList && this.ccCartOutputData.memberEventList.length) ? this.ccCartOutputData.memberEventList : [],
					'roleTextWithValue': (this.ccCartOutputData && this.ccCartOutputData.roleTextWithValue && this.ccCartOutputData.roleTextWithValue.length) ? this.ccCartOutputData.roleTextWithValue : [],
					'memberTextWithValue': (this.ccCartOutputData && this.ccCartOutputData.memberTextWithValue && this.ccCartOutputData.memberTextWithValue.length) ? this.ccCartOutputData.memberTextWithValue : [],
					'isCc': true,
					'TemplateDetails': this.TemplateDetails
				}
			});

			dialogRef.afterClosed().subscribe((output: WFTCartDialogOutputModel) => {
				if (output) {
					this.ccCartOutputData = output;
					let tooltipData = (this.ccCartOutputData && this.ccCartOutputData.totalSelectedNames) ? this.ccCartOutputData.totalSelectedNames : ''
					this.formGroup.get('ccSelectedNames')?.setValue(tooltipData);
				}
			});
		}
	}

	/**
	 * Action cart component output data
	 * @param event
	 */
	getActionCartValue(event: any) {
		this.actionCartOutputData = event
	}

	saveBodyInputData() {
		if (this.actionCartOutputData && this.actionCartOutputData.length > 0)
			this.actionCartOutputData.forEach(val => {
				val["is_Approval_Status"] = this.formGroup.get('is_Approval_Status')?.value;
			})
		if (!this.actionComponent.isAllActionsSaved()) {
			this.notificationService.showToast("Some of the workflow action(s) are not considered", 'Warning');
			return;
		}

		let output: any = {
			'inputFormGroupValue': {},
			'toCart': [],
			'ccCart': [],
			'actionCart': []
		};

		if (this.workflowTemplateService.isCopyMode) {
			if (!this.formGroup.get('workflow_Status')?.value) {
				this.getInputValues.emit(output);
			} else {
				let output: any = {
					'inputFormGroupValue': this.validateInputFormGroupValues(this.formGroup.value),
					'toCart': this.formatCartData(this.toCartOutputData, 1),
					'ccCart': this.formatCartData(this.ccCartOutputData, 2),
					'actionCart': this.validateActionCartValues(this.actionCartOutputData), // validation done in child component
				};

				if (!output.toCart.length) {
					this.notificationService.showToast("Select atleast either one Role or Member in To:", 'Warning');
					return;
				}

				if (!output.actionCart.length) {
					this.notificationService.showToast("Select atleast one Workflow Action", 'Warning');
					return;
				}
				this.getInputValues.emit(output);
			}
		} else {
			if (!this.formGroup.get('workflow_Status')?.value) {
				this.notificationService.showToast("Select Workflow task", "Warning");
				return;
			}

			if (!this.formGroup.get('sub_Workflow')?.value) {
				this.notificationService.showToast("Select Workflow stage", "Warning");
				return;
			}

			if (this.isTransmittalSelectionRequired && !this.formGroup.get('transmittal_Page')?.value) {
				this.notificationService.showToast("Select Transmittal", "Warning");
				return;
			}

			if (this.formGroup.get('due_Days')?.value < 1) {
				this.notificationService.showToast("'Complete task within days' should be more than 0", "Warning");
				return;
			}

			if (this.formGroup.get('is_Due_On')?.value) {
				this.formGroup.get('status_Id')?.setValue(this.formGroup.get('sub_Workflow')?.value);
			} else {
				this.formGroup.get('status_Id')?.setValue(null);
			}

			if (this.formGroup.get('integration_Type')?.value && this.getWorkflowIntegrateToName(this.formGroup.get('integration_Type')?.value).toLowerCase().trim() != 'dtn preparation') {
				if (this.formGroup.get('Is_SignedCopy_Required')?.value && this.formGroup.get('Is_SignedCopy_Required')?.value == true) {
					this.notificationService.showToast("'Signed copy' is applicable for the Integration Type of 'DTN Preparation' only", "Warning");
					return;
				}
			}

			if (this.formGroup.get('is_Approval_Status')?.value && this.formGroup.get('is_Due_On')?.value &&
				this.formGroup.get('is_Approval_Status')?.value == true && this.formGroup.get('is_Due_On')?.value == true) {
				this.notificationService.showToast("'Is Approval Status' and 'Is Due On' should not be enabled in same step", "Warning");
				return;
			}

			let output: any = {
				'inputFormGroupValue': this.validateInputFormGroupValues(this.formGroup.value),
				'toCart': this.formatCartData(this.toCartOutputData, 1),
				'ccCart': this.formatCartData(this.ccCartOutputData, 2),
				'actionCart': this.validateActionCartValues(this.actionCartOutputData), // validation done in child component
			};

			if (!output.toCart.length) {
				this.notificationService.showToast("Select atleast either one Role or Member in To:", 'Warning');
				return;
			}

			if (!output.actionCart.length) {
				this.notificationService.showToast("Select atleast one Workflow Action", 'Warning');
				return;
			}
			this.getInputValues.emit(output);
		}
	}

	public getWorkflowIntegrateToName(id: number) {
		if (this.integrateToList.filter(item => item.dedId == id).length > 0)
			return this.integrateToList.filter(item => item.dedId == id)[0]["dedDescription"];
		else
			return '';
	}

	/**
	 * Change To and Cc cart data to appropirate request API data format
	 * @param data Cart output data
	 * @param assignType 1= to, 2 = cc
	 */
	formatCartData(data: WFTCartDialogOutputModel | null, assignType: 1 | 2): WorkflowAssignedToModel[] {
		let outputArr: any = [];

		if (!data) {
			return [];
		}

		data.memberEventList.forEach(eachMember => {
			let splitedCartValue = this.spiltCartTextValue(eachMember.text),
				newObj: any = {
					"workflow_Id": null,
					"task_Id": null, // common task id
					"member_Id": splitedCartValue.value,
					"member_Name": splitedCartValue.name,
					"role_Id": 0,
					"role_Description": '',
					"group_Id": data.previousBusinessGroupId, // selected bg id
					"assign_Type": assignType, // 2 = cc, 1= to
					"assign_Order": 1,
					"is_Active": true,
				};
			outputArr.push(newObj);
		});

		data.roleEventsList.forEach(eachRole => {
			let splitedCartValue = this.spiltCartTextValue(eachRole.text),
				newObj: any = {
					"workflow_Id": null,
					"task_Id": null, // common task id
					"member_Id": 0,
					"member_Name": '',
					"role_Id": splitedCartValue.value,
					"role_Description": splitedCartValue.name,
					"group_Id": data.previousBusinessGroupId, // selected bg id
					"assign_Type": assignType, // 2 = cc, 1= to
					"assign_Order": 1,
					"is_Active": true,
				};
			outputArr.push(newObj);
		});
		outputArr.forEach((each: any) => {
			each.task_Id = this.workflowTemplateService.selectedTaskId;
		});
		return outputArr;
	}

	validateInputFormGroupValues(input: WorkflowTemplateStatusInputModel): any {
		if (!input) {
			return [];
		}

		if (!input.due_Days) {
			input.due_Days = null;
		}

		return input;
	}

	validateActionCartValues(actionKendoList: any) {
		if (!actionKendoList) {
			return [];
		}

		actionKendoList.forEach((each: any) => {
			each.task_Id = this.workflowTemplateService.selectedTaskId;
		});

		// if any validation needed, do here
		return actionKendoList;
	}

	spiltCartTextValue(input: string): {
		value: string,
		name: string
	} {
		let textWithValueArr = input.split('-'),
			value = textWithValueArr[0].trim(),
			name = textWithValueArr[1].trim();
		return {
			value,
			name
		};
	}

	getApprovalStatusValue() {
		this.actionComponent.getApprovalValue(this.formGroup.get('is_Approval_Status')?.value)
	}

	createNewStep() {
		//this.parentWorkflowId = 0;
		this.workflowTemplateService.supportForClearInputData.next(true);
		this.workflowTemplateService.isViewMode = false;
		this.workflowTemplateService.isEditMode = false;
		this.workflowTemplateService.isCopyMode = false;
		this.syncBottomKendoListWithWfTaskList();
		this.parentTaskId = this.bottomKendoList.length + 1;
		this.workflowTemplateService.selectedTaskId = this.bottomKendoList.length + 1;

	}
}